import { tryDeriveApiUrl } from '@vl-core/getApiEndpoint';
import ServiceApi from 'vl-common/src/services/service.api';

const apiUrl = tryDeriveApiUrl();

export const getArticleNo = (category) => {
  return async () => {
    return await fetch(`${apiUrl}/outputs/confluence/APPUSER/${category}`);
  };
};
export const fetchArticle = (article) => {
  return async () => {
    return await ServiceApi.get(`/article/${article}`);
  };
};

export const fetchArticleFromDB = (article) => {
  return async () => {
    const res = await ServiceApi.get(`/outputs/template/html?user_guid=APPUSER&template_code=${article}`);
    console.log('res', res);
    return res;
  };
};

export const fetchArticleNoAuth = (article) => {
  return async () => {
    const res = await fetch(`${apiUrl}/article/${article}`);
    return await res.json();
  };
};
export const fetchArticleNoAuthFromDB = (article) => {
  return async () => {
    const res = await fetch(`${apiUrl}/content/${article}`);
    return await res.json();
  };
};
